import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { MessageHelper } from '../../../../core/helpers/message-helper';
import { StateHeadCompany } from '../../../models/head-company.model';

@Component({
    selector: 'app-head-office-section',
    templateUrl: './head-office-section.component.html',
    styleUrls: ['./head-office-section.component.scss'],
    standalone: false
})
export class HeadOfficeSectionComponent implements OnInit {
  @Input() headOffice?: StateHeadCompany;

  constructor(private shared: SharedService) {

  }

  ngOnInit(): void {
  }
  
  
  get annualReturnFilingText(): string {
    return MessageHelper.GetTextForDayAndMonth(this.headOffice!.annualReturnFilingDay, 
      this.headOffice!.annualReturnFilingMonth);
  }
  get financialYearEndText(): string {
    return MessageHelper.GetTextForDayAndMonth(this.headOffice!.financialYearEndDay, 
      this.headOffice!.financialYearEndMonth);
  }

  public getCountryNameById(id: any): string {
    return this.shared.getCountryNameById(Number(id));
  }
}